(() => {
  const SCROLL_TOLERANCE = 2;

  const getScrollStep = (track) => {
    const list = track.querySelector('.collection-subcollections__list');
    const firstItem = list?.querySelector('.collections-grid__card');

    if (!firstItem) {
      return track.clientWidth * 0.8;
    }

    const gap = list ? parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap) || 0 : 0;
    return firstItem.offsetWidth + gap;
  };

  const updateArrows = (slider) => {
    const track = slider.querySelector('[data-subcollections-track]');
    const prev = slider.querySelector('[data-subcollections-prev]');
    const next = slider.querySelector('[data-subcollections-next]');

    if (!track || !prev || !next) return;

    const overflows = track.scrollWidth > track.clientWidth + SCROLL_TOLERANCE;

    prev.classList.toggle('is-visible', overflows);
    next.classList.toggle('is-visible', overflows);
    slider.classList.toggle('collection-subcollections__slider--scrollable', overflows);

    if (!overflows) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    const atStart = track.scrollLeft <= SCROLL_TOLERANCE;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - SCROLL_TOLERANCE;

    prev.disabled = atStart;
    next.disabled = atEnd;
  };

  const scrollTrack = (track, direction) => {
    const amount = getScrollStep(track);

    track.scrollBy({
      left: direction === 'next' ? amount : -amount,
      behavior: 'smooth',
    });
  };

  const initSlider = (slider) => {
    if (!slider || slider.dataset.initialized === 'true') return;
    if (slider.closest('.collection-subcollections--wrapped')) return;
    if (document.body.classList.contains('body-template-collection-sub-collection-template')) return;

    const track = slider.querySelector('[data-subcollections-track]');
    const prev = slider.querySelector('[data-subcollections-prev]');
    const next = slider.querySelector('[data-subcollections-next]');

    if (!track) return;

    slider.dataset.initialized = 'true';

    prev?.addEventListener('click', () => scrollTrack(track, 'prev'));
    next?.addEventListener('click', () => scrollTrack(track, 'next'));
    track.addEventListener('scroll', () => updateArrows(slider), { passive: true });

    const resizeObserver = new ResizeObserver(() => updateArrows(slider));
    resizeObserver.observe(track);

    const list = track.querySelector('.collection-subcollections__list');
    if (list) resizeObserver.observe(list);

    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => updateArrows(slider), { once: true });
      }
    });

    updateArrows(slider);
  };

  const initSection = (root) => {
    if (!root) return;

    root.querySelectorAll('[data-subcollections-slider]').forEach(initSlider);
  };

  const initAll = () => {
    document.querySelectorAll('.section-collection-subcollections').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
  });
})();
